// Video popup functionality
const popupTriggers = document.querySelectorAll('.js-popup-trigger');
const popupBody = document.querySelector('.js-popup');

if (popupBody) {
  const popupClose = popupBody.querySelector('.custom-popup__close');
  const videoFrame = popupBody.querySelector('iframe');

  popupTriggers.forEach(popupTrigger => {
    const videoURL = popupTrigger.getAttribute('data-url');
    popupTrigger.addEventListener('click', (e) => {
      e.preventDefault();

      popupBody.classList.add('is-opened');
      videoFrame.src = videoURL + '?autoplay=1';
    });
  });

  popupClose.addEventListener('click', () => {
    popupBody.classList.remove('is-opened');
    videoFrame.src = '';
  });

  window.addEventListener('click', (e) => {
    if (e.target === popupBody) {
      popupBody.classList.remove('is-opened');
      videoFrame.src = '';
    }
  });
}

// Color swatches — sync with Shopify.OptionSelectors (select.single-option-selector).
// product.liquid has no .produkt_select-open links (unlike alternatives_produkt); swatches must update the option selects directly.
const swatches = document.querySelectorAll('.js-swatch');

function updateOptionSelectedLabel(optionHandle, selectedValue) {
  if (!optionHandle) return;

  const label = document.querySelector(`[data-option-label="${optionHandle}"] .js-option-selected-value`);
  if (label) {
    label.textContent = selectedValue;
  }
}

function updateSwatchSelectedState(optionHandle, selectedValue) {
  if (!optionHandle) return;

  const optionWrapper = document.querySelector(`.dropdown-single[data-option-handle="${optionHandle}"]`);
  if (!optionWrapper) return;

  optionWrapper.querySelectorAll('.produkt_select__swatches li').forEach((item) => {
    item.classList.remove('is-selected');
  });

  const escapedValue = window.CSS && typeof window.CSS.escape === 'function'
    ? window.CSS.escape(selectedValue)
    : selectedValue.replace(/"/g, '\\"');
  const selectedSwatch = optionWrapper.querySelector(`.js-swatch[data-option-value="${escapedValue}"]`);
  if (selectedSwatch && selectedSwatch.parentElement) {
    selectedSwatch.parentElement.classList.add('is-selected');
  }
}

function applySwatchToOptionSelectors(swatchEl) {
  const optionHandle = swatchEl.getAttribute('data-option');
  const optionValue = swatchEl.getAttribute('data-option-value');
  if (!optionHandle || optionValue === null || optionValue === '') return false;

  const scope = swatchEl.closest('.produkt_select-wrapper')
    || swatchEl.closest('[udy-el="single-add-to-cart-select"]');
  if (!scope) return false;

  const dropdownRows = scope.querySelectorAll('.dropdown-single[data-option-handle]');
  let optionIndex = -1;
  dropdownRows.forEach((row, i) => {
    if (row.getAttribute('data-option-handle') === optionHandle) {
      optionIndex = i;
    }
  });
  if (optionIndex < 0) return false;

  const selects = scope.querySelectorAll('select.single-option-selector');
  const select = selects[optionIndex];
  if (!select) return false;

  if (typeof jQuery !== 'undefined') {
    jQuery(select).val(optionValue).trigger('change');
  } else {
    select.value = optionValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
  return true;
}

swatches.forEach(function(swatch) {
  swatch.addEventListener('click', function(e) {
    const optionHandle = this.getAttribute('data-option');
    const optionValue = this.getAttribute('data-option-value');

    // In-Place-Wechsel immer bevorzugen (auch bei echtem ?variant=-Href):
    // kein Full-Reload, kein Sprung nach oben. Shopify.OptionSelectors
    // (enableHistoryState:true) haelt dabei die ?variant=-URL in der Adresszeile
    // synchron via replaceState. Erst preventDefault, wenn wir wirklich uebernehmen.
    if (applySwatchToOptionSelectors(this)) {
      e.preventDefault();
      updateOptionSelectedLabel(optionHandle, optionValue);
      updateSwatchSelectedState(optionHandle, optionValue);
      return;
    }

    const selector = `.produkt_select-open[data-option="${optionHandle}"][data-option-index="${this.getAttribute('data-option-index')}"]`;
    const optionLink = document.querySelector(selector);
    if (optionLink) {
      e.preventDefault();
      optionLink.click();
      updateOptionSelectedLabel(optionHandle, optionValue);
      updateSwatchSelectedState(optionHandle, optionValue);
      return;
    }

    // Kein passender Select/Alt-Link gefunden: echter Href navigiert normal
    // (No-JS-Fallback / teilbarer SEO-Link bleibt erhalten).
  });
});

document.querySelectorAll('.produkt_select-open').forEach((optionLink) => {
  optionLink.addEventListener('click', function() {
    const optionHandle = this.getAttribute('data-option');
    const optionValue = this.textContent.trim();
    updateOptionSelectedLabel(optionHandle, optionValue);
    updateSwatchSelectedState(optionHandle, optionValue);
  });
});

// Product Countdown
const timerWrapper = document.querySelector('#product-countdown');

if (timerWrapper) {
  const COOKIE_NAME = "countdown_end";
  const HOURS_48 = 48 * 60 * 60 * 1000;

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function setCookie(name, value, msFromNow) {
    const expires = new Date(Date.now() + msFromNow).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  let endTime = getCookie(COOKIE_NAME);

  if (!endTime) {
    endTime = Date.now() + HOURS_48;
    setCookie(COOKIE_NAME, endTime, HOURS_48);
  } else {
    endTime = parseInt(endTime);
  }

  function updateTimer() {
    const now = Date.now();
    const remaining = endTime - now;
    const timerElement = document.querySelector('.product-countdown__time');

    if (remaining <= 0) {
      document.querySelector('#product-countdown').classList.add('hidden')
      return;
    }

    const totalHours = Math.floor(remaining / (1000 * 60 * 60));
    timerElement.textContent = `${totalHours} hour${totalHours > 1 ? 's' : ''}`;

    requestAnimationFrame(updateTimer);
  }

  updateTimer();
}

// Features list
document.querySelectorAll('.product-block--features .js-show-more').forEach(button => {
  button.addEventListener('click', function(e) {
    e.preventDefault()

    if (button.classList.contains('clicked')) {
      button.textContent = 'Show More'
      button.classList.remove('clicked');
    } else {
      button.textContent = 'Show Less';
      button.classList.add('clicked');
    }

    const hiddenElements = document.querySelectorAll('.list-features .js-hidden');
    hiddenElements.forEach(element => {
      element.classList.contains('hidden') ? element.classList.remove('hidden') : element.classList.add('hidden')
    })
  })
});

// Show filters
const filtersTrigger = document.querySelectorAll('.js-show-filters');
const bodyElement = document.querySelector('body');
const filtersDrawer = document.querySelector('.collection-filters');

if (filtersTrigger && filtersTrigger.length > 0 && filtersTrigger[0]) {
  filtersTrigger[0].addEventListener('click', function(e) {
    e.preventDefault();

    const firstFilterContent = document.querySelectorAll('.kategorie_filter-grid .filter_content')[0];
    if (firstFilterContent) firstFilterContent.classList.toggle('active');
  })
}

// Sort click
const sortHeader = document.querySelector('.filter_header--sort');
if (sortHeader) {
  sortHeader.addEventListener('click', function() {
    const sortInputs = document.querySelector('.filter_inputs--sort');
    if (sortInputs) sortInputs.classList.toggle('active')
  })
}

const sortCustomOptions = document.querySelectorAll('.js-sort')
sortCustomOptions.forEach(selector => {
  selector.addEventListener('click', function(e) {
    e.preventDefault();

    sortCustomOptions.forEach(link => link.classList.remove('is-active'))
    selector.classList.add('is-active')

    const dataValue = selector.getAttribute('data-value');
    const sortSelector = document.getElementById('field-2');

    if (sortSelector) {
      sortSelector.value = dataValue;
      sortSelector.dispatchEvent(new Event('change'))
    }
  })
})

